import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faIndustry, faThumbsUp, faSmile, faClock, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import ProgressBar from './ProgressBar';

import counterbg from "../assets/images/background/counter-bg.jpg"

const SkillsSection = () => {
  return (
    <section className="skills-area">
      <div className="container">
        <div className="row">
          <div className="col-xl-9">
            <div className="skills-content mt-60 mb-70 rmt-0 rel z-1 wow fadeInLeft delay-0-2s">
              <div className="row">
                <div className="col-lg-7">
                  <div className="section-title mb-55">
                    <span className="sub-title mb-15">Skills & Experience</span>
                    <h2>Small Enough to Care, Big Enough to Succeed</h2>
                    <span className="bg-text">Skills</span>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* Instruments Manufactured */}
                <div className="col-lg-4 col-md-6">
                  <div className="circle-progress-item bgc-secondary text-white">
                    <div className="progress-content one">
                      <ProgressBar value={1500000} color="#ffff" />
                    </div>
                    <h4>
                      <FontAwesomeIcon icon={faIndustry} /> <br></br>Instruments Manufactured
                    </h4>
                    <p>
                      Over 1,500 instruments manufactured, ensuring precision in every piece.
                    </p>
                  </div>
                </div>

                {/* Client Satisfaction */}
                <div className="col-lg-4 col-md-6">
                  <div className="circle-progress-item bgc-primary text-white">
                    <div className="progress-content two">
                      <ProgressBar value={995} color="#ffff" emptyFill={"#fff"} />
                    </div>
                    <h4>
                      <FontAwesomeIcon icon={faThumbsUp} /> <br></br>Client Satisfaction
                    </h4>
                    <p>
                      995 out of 1,000 clients satisfied with our products and services.
                    </p>
                  </div>
                </div>

                {/* Years of Experience */}
                <div className="col-lg-4 col-md-6">
                  <div className="circle-progress-item bg-white">
                    <div className="progress-content three">
                      <ProgressBar value={25} color="#000" emptyFill={"#000"} />
                    </div>
                    <h4>
                      <FontAwesomeIcon icon={faClock} /> <br></br> Years of Experience
                    </h4>
                    <p>
                      25 years of expertise in manufacturing top-quality surgical instruments.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
          className="skills-bg"
          style={{
            backgroundImage: `url(${counterbg})`,
          }}
        />
    </section>
  );
};

export default SkillsSection;
